import type { FaireProductEntity } from "../../entity_types/product";

export const p_anrekryv43: FaireProductEntity = {
  token: "p_anrekryv43",
  type: "product",
  name: "Santa Cruz Organic - Lemonade Strawberry - Case Of 8-16 Oz",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/8327b4e09a8925646f8ea17e022c3df440202aab633e16ec887cc9ff747a921c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee89fdcf5e0c7342760190606d8ba2da57820586a86285217271fd7bf8a83110.jpeg",
    "https://cdn.faire.com/fastly/777fff436f23814643c5d002be41920b75cb5edb1d4023a3dbee8a7f76cae96d.jpeg",
  ],
  priceDollars: 49.15,
  description:
    "\n\nQuench your thirst with a delightful blend of ripe strawberries and tangy lemons in every sip. This refreshing beverage is crafted with over 95% organic ingredients, ensuring a natural and authentic taste. Made in California, USA, it is a gluten-free and GMO-free choice for health-conscious individuals.\n\n * Packaged in convenient 16 oz bottles, perfect for on-the-go refreshment. \n * Contains organic sugar and organic strawberry puree for a naturally sweet flavor. \n * Includes organic lemon juice concentrate for a zesty kick. \n * Enhanced with organic fruit and vegetable juice for vibrant color and taste. \n * Sold in a pack of 8, ideal for sharing with friends and family. \nEnjoy the pure, fruity goodness of this Strawberry Lemonade, perfect for picnics, parties, or simply a relaxing day at home.\n",
  tags: [],
  msrpDollars: 98.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:04.577Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
